/** @prettier */

/**
 * 削除ダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {useState} from 'react';
import {Storage} from 'aws-amplify';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//API import
import {patchSettingUser} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {file} from '../../define';

/**
 * ロゴ画像削除ダイアログ
 * @param props props
 * @returns JSX.Element
 */
const LogoDeleteDialog = (props: {
  /** ロゴの名前 */
  logoName: string;
  /** ダイアログ表示フラグ */
  isOpenDialog: boolean;
  /** ダイアログ表示フラグ設定関数 */
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const trans = useTranslation().t; //翻訳関数
  Storage.configure({customPrefix: {private: file.LOGO_S3_KEY_PREFIX}});

  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * OKボタン押下時処理
   */
  const deleteImage = () => {
    setAPIWait(true);

    //画像削除
    Storage.remove(props.logoName, {level: 'private'})
      .then(response => {
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
        window.location.reload();
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="logo-initialize-title">
        <DialogTitle id="logo-initialize-title">
          {trans('WebsiteSettingDeleteDialog.logo.title')}
        </DialogTitle>
        <DialogContent>
          {/* ダイアログに表示するメッセージ */}
          <DialogContentText className="accountSetting__dialog__content__text">
            {trans('WebsiteSettingDeleteDialog.logo.msg')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={handleClose}
            buttonText={trans('WebsiteSettingDeleteDialog.buttonTxt.cancel')}
          />
          <PrimaryButton
            onClick={deleteImage}
            buttonText={trans('WebsiteSettingDeleteDialog.buttonTxt.ok')}
            apiWait={apiWait}
            disabled={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
      />
    </>
  );
};

/**
 * フッター削除ダイアログ
 * @param props props
 * @returns JSX.Element
 */
const FooterDeleteDialog = (props: {
  /** ダイアログ表示フラグ */
  isOpenDialog: boolean;
  /** ダイアログ表示フラグ設定関数 */
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const trans = useTranslation().t; //翻訳関数

  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * OKボタン押下時処理
   */
  const deleteFooter = () => {
    setAPIWait(true);

    const body: apiIF.reqParameters.patchSettingUser = {
      'footer-text': '© Mitsubishi Heavy Industries Thermal Systems, Ltd.',
    };
    patchSettingUser(body)
      .then(() => {
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
        window.location.reload();
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('WebsiteSettingDeleteDialog.footer.title')}
        </DialogTitle>
        <DialogContent>
          {/* ダイアログに表示するメッセージ */}
          <DialogContentText className="accountSetting__dialog__content__text">
            {trans('WebsiteSettingDeleteDialog.footer.msg')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={handleClose}
            buttonText={trans('WebsiteSettingDeleteDialog.buttonTxt.cancel')}
          />
          <PrimaryButton
            onClick={deleteFooter}
            buttonText={trans('WebsiteSettingDeleteDialog.buttonTxt.ok')}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
      />
    </>
  );
};
export {LogoDeleteDialog, FooterDeleteDialog};
